import request from "@/utils/http"

export function createOptionSet(data, appId) {
  return request.post(`/sheet/optionSet/create`, data, { params: { appId } }).commonDeal()
}

export function getOptionSet(id) {
  return request.get(`/sheet/optionSet/get`, { params: { id } }).commonDeal()
}

export function getOptionSetList() {
  return request.get(`/sheet/optionSet/list`).commonDeal()
}

export function updateOptionSet(data) {
  return request.post(`/sheet/optionSet/update`, data).commonDeal()
}
